<script setup lang="ts">
import { graphql } from '@/gql';
import LoadingIndicator from 'theme/components/atoms/LoadingIndicator.vue';
import SettingsNotificationTemplate from '~/components/templates/SettingsNotificationTemplate/SettingsNotificationTemplate.vue';

const query = graphql(`
  query SettingsNotificationViewer {
    viewer2 {
      ... on ViewerQuerySuccessPayload {
        result {
          id
          ...SettingsNotificationTemplateViewer
        }
      }
    }
  }
`);

const { result } = await useQuery(query, {}, { prefetch: false });
const viewer = computed(() => {
  if (result.value?.viewer2.__typename !== 'ViewerQuerySuccessPayload') {
    return null;
  }
  return result.value.viewer2.result;
});
</script>

<template>
  <SettingsNotificationTemplate v-if="viewer" :viewer="viewer" />
  <div v-else :class="$style.loading">
    <LoadingIndicator />
  </div>
</template>

<style lang="scss" module>
.loading {
  display: flex;
  justify-content: center;
  margin-top: 64px;
}
</style>
